import _Vue from 'vue';
import { LoadingPluginOptions } from './options';
const Loading = require('./Loading.vue').default;

class LoadingStoreState {
  public isLoading = false;
  public requisitions: number[] = [];
}

export const LoadingActionTypes = {
  START: 'loading/START',
  FINISH: 'loading/FINISH'
};

export default function LoadingPlugin(Vue: typeof _Vue, options: LoadingPluginOptions): void {
  options.store.registerModule<LoadingStoreState>('loading', {
    state: new LoadingStoreState(),
    namespaced: true,
    mutations: {
      SET: (state: any, value: boolean) => {
        state.isLoading = value;
      },
      ADD_REQUISITION: (state: any, route: string) => {
        if (!state.requisitions.some((req: string) => req === route)) {
          state.requisitions.push(route);
        }
      },
      REMOVE_REQUISITION: (state: any, route: string) => {
        Vue.set(state, 'requisitions', state.requisitions.filter((req: string) => req !== route))
      }
    },
    actions: {
      START: (injectee: any, type: string) => {
        injectee.commit('ADD_REQUISITION', type);
        setTimeout(() => {
          if (injectee.state.requisitions.length > 0) {
            injectee.commit('SET', true);
          }
        }, options.timeout);
      },
      FINISH: (injectee: any, type: string) => {
        injectee.commit('REMOVE_REQUISITION', type);
        if (injectee.state.requisitions.length < 1) {
          injectee.commit('SET', false);
        }
      }
    }
  });
  options.router.beforeEach((to: any, from: any, next: any) => {
    if (to.fullPath !== from.fullPath) {
      options.store.dispatch('loading/START', 'router');
    }
    next();
  });
  options.router.afterEach(() => {
    options.store.dispatch('loading/FINISH', 'router');
  });

  Vue.component('global-loading', Loading);
}
